﻿
import Vue from "vue";
import './style.scss';

var previousAjax;
var nextCallback = null;

var basePath = window.app.base;

var instance = new Vue({
    data: {
        modalTitle: '',
        controller: '',
        searchText: '',
        results: [],
        ajaxUrl: null,
        selectedItem: {
            DataText: null,
            DataValue: null
        }
    },
    methods: {
        onInput: function () {
            var q = this.searchText;
            var c = this;

            this.selectedItem.DataText = null;
            this.selectedItem.DataValue = null;
            //if (previousAjax) {
            //    previousAjax.abort();
            //}

            previousAjax = $.ajax({
                url: this.ajaxUrl,
                method: "GET",
                data: {
                    name: q
                }
            }).then(function (result) {
                c.results = [];

                for (var i = 0; i < result.length; i++) {
                    c.results.push({ DataText: result[i].Name, DataValue: result[i].Id });
                }

            }).fail(function () {
                // on fail .......
            });
        },

        selectItem: function (re) {
            this.selectedItem = re;
        },

        openPrompt: function (controllerName, modalTitle, callback) {

            $(this.$el).find(".form-actions .btn.primary").prop("disabled", false);
            $(this.$el).modal('show');
            $(this.$el).find("input[type='text']").focus();

            this.controller = controllerName;
            this.modalTitle = modalTitle;
            nextCallback = callback;

            $(this.$el).on('hidden.bs.modal', function () {
                $("body").addClass("modal-open");
            });

            this.ajaxUrl = basePath + controllerName + "/FilterByPropertyName";
        },

        cancel: function () {
            $(this.$el).modal('hide');

        },

        save: function () {
            var item = this.selectedItem;

            if (this.controller === "PNAdresa" && item.DataValue == null) {
                var $el = $(this.$el);
                $el.find(".form-actions .btn.primary").prop("disabled", true);
                $.ajax({
                    url: basePath + "PNAdresa/CreateByName",
                    data: {
                        name: this.searchText
                    },
                    method: "POST"
                }).then(function (res) {
                    if (res.success) {
                        var dto = res.result;

                        $el.modal('hide');

                        nextCallback({
                            valueChanged: true,
                            newValue: dto.Id,
                            newValueText: dto.Naziv
                        });
                    }
                    $(this.$el).find(".form-actions .btn.primary").prop("disabled", false);
                });

            }
            else {

                $(this.$el).modal('hide');

                nextCallback({
                    valueChanged: true,
                    newValue: item.DataValue,
                    newValueText: item.DataText
                });
            }

        }
    }
});


var component = {
    v: instance,
    name: "popup-reference-field"
};

export default component;